import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import AmenityBig from '../AmenityBig';
import React from 'react';

const AmenityColiving = props => {
  const data = props;

  return (
    <div>
      <HeadingSection title={data.heading} bgcolor="white" />
      <div className="lg:container mx-auto mb-4 pt-3 pb-3">
        <div className="px-10 md:px-0 2xl:px-2">
          <div className="flex justify-center 2xl:px-4 ">
            <div className=" w-full">
              <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2   gap-[2px]">
                <div className=" ">
                  <AmenityBig title={data.title1} img="aminitiesCard" bgImg={data.img1} />
                </div>
                <div className="">
                  <AmenityBig title={data.title2} img="aminitiesCard" bgImg={data.img2} />
                </div>
                <div className="">
                  <AmenityBig title={data.title3} img="aminitiesCard" bgImg={data.img3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenityColiving;
